export default "__VITE_ASSET__ClAXSxn6__"